import { render, staticRenderFns } from "./endorsement.vue?vue&type=template&id=05ac70ba"
import script from "./endorsement.vue?vue&type=script&lang=js"
export * from "./endorsement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports